import { BatchService } from 'projects/services/src/app/API/batch.service';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'projects/services/src/app/shared/shared.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'projects/services/src/app/API/user.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { CandidatesDetails } from 'src/app/models/candidatesDetails';
declare var toastr: any;
declare var swal: any;

@Component({
	selector: 'app-view-applicant-details',
	templateUrl: './view-applicant-details.component.html',
	styleUrls: ['./view-applicant-details.component.css']
})
export class ViewApplicantDetailsComponent implements OnInit {
	candidatesRoleData: CandidatesDetails = new CandidatesDetails();
	public data = [];
	actionForm: FormGroup;
	actionRejectedForm: FormGroup;
	paymentDetails: any;
	batchCandidates: any;
	batchFees: any;
	domainJobRole: any;
	isSSC: boolean;
	role: any;
	batchId: any;
	username: any;
	currentUserDetails: any;
	profilePhoto: string;
	candidatesData: any;
	deriveFileNameFromS3Url = Helpers.deriveNameFromS3Url;
	routeParams: any;
	routeQueryParams: any;
	candidateResume: any
	buttonText = 'View CV/Resume';
	requestStatus: any;
	rejectedReasonsDropDownData: any[];
	requestData: any;
	settings: any;
	requestTotakeAction: any[];
	actionForRequest = false;
	actionForApplicant = false;
	experienceFor: any;
	totalWorkingExperienceMonths = 0;
	totalTrainingExperienceMonths = 0;

	batchType: any;
	constructor(
		private _activatedRoute: ActivatedRoute,
		private shareService: SharedService,
		private fileService: FileService,
		private totBatchService: TotBatchService,
		private batchservice: BatchService,
		private _location: Location,
		private _formBuilder: FormBuilder,
		private userService: UserService,
		private router: Router,
		private currentUserService: CurrentUserService
	) {
		_activatedRoute.params.subscribe(res => {
			this.batchId = res.id;
			this.username = res.candidateId;
			this.role = res.role;
		});
		this.shareService.getProfilePhoto().subscribe(res => {
			if (res) {
				this.getProfilePhoto(res);
				console.log(res, 'photo');
			}
		});
	}

	ngOnInit() {
		this.routeParams = this._activatedRoute.snapshot.params;
		this.routeQueryParams = this._activatedRoute.snapshot.queryParams;
		this.getcurrentUser();
		if (this.batchId) {
			this.getBatchDetails();
		}
		this.getCandidateDetail();
		this.createActionForm();
		this.getRejectReasons();
		// this.createRejectedActionForm();
		this.settings = {
			singleSelection: true,
			text: 'Select',
			enableSearchFilter: true,
			showCheckbox: false
		};
	}
	getBatchDetails() {
		this.batchservice.getBatchDetails(this.batchId).subscribe(batch => {
			this.batchType = batch.type
			this.domainJobRole = batch.jobRoles.filter(data => {
				return data.isPlatformQP === false;
			})
			this.batchCandidates = batch.candidates;
			if (this.batchCandidates) {
				this.getPaymentDetails();
			}
			this.batchFees = batch.batchFee;
		}, err => { }
		)
	}

	getcurrentUser() {
		this.currentUserService.getCurrentUser().subscribe(
			data => {
				this.currentUserDetails = data;
				console.log(data.role);
				if (data.role === 'SSC') {
					this.isSSC = true;
				} else {
					this.isSSC = false;
				}
			},
			error => {
				console.log(`Error in fetching current user detail ${error}`);
			}
		);
	}

	getProfilePhoto(photoUrl) {
		this.fileService.getImageURL(photoUrl).subscribe(res => {
			this.profilePhoto = res;
		});
	}

	getCandidateDetail() {
		if (this.role !== 'Candidate') {
			if (this.role === 'masterAssessor' || this.role === 'assessor') {
				this.role = 'assessor';
				this.experienceFor = 'Assessment'
			} else if (this.role === 'masterTrainer' || this.role === 'trainer') {
				this.role = 'trainer';
				this.experienceFor = 'Training'
			}
			this.totBatchService
				.getCandidateDetails(this.role.toLowerCase(), this.username)
				.subscribe(res => {
					console.log('new candidates', res, this.routeQueryParams);
					if (res.photo && res.photo.url && res.photo.url !== "") {
						this.shareService.setProfilePhoto(res.photo.url);
						this.getProfilePhoto(res.photo.url);
					}
					if (res.preferences) {
						this.requestTotakeAction = res.preferences.find(pref => {
							if (this.routeQueryParams.trReqId) {
								this.actionForApplicant = false;
								if (pref.trainingReqId === Number(this.routeQueryParams.trReqId)) {
									if (pref.status === 'PENDING') {
										this.actionForRequest = true;
										return pref;
									}
								} else {
									this.actionForRequest = false;
								}
							} else {
								this.actionForApplicant = true;
								this.actionForRequest = false;
							}
							console.log(this.requestTotakeAction);
						})
					}
					this.candidatesData = res;
					this.totalWorkingExperienceMonths = res.totalIndustrialExperienceInMonth;
					this.totalTrainingExperienceMonths = res.totalTrainingExperienceInMonth;
					if (this.candidatesData && this.candidatesData.education && this.candidatesData.education.length) {
						for (let i = 0; i < this.candidatesData.education.length; i++) {
							// tslint:disable-next-line:max-line-length
							if (this.candidatesData.education[i] && this.candidatesData.education[i].supportingDocument && this.candidatesData.education[i].supportingDocument !== '') {
								this.candidatesData.education[i].file = this._deriveNameFromS3Url(this.candidatesData.education[i].supportingDocument);
							}
						}
					}
				});
		} else {
			this.batchservice.candidateDetails(this.username).subscribe(res => {
				console.log('new candidates', res);
				this.data = res.message;
				this.candidatesRoleData.userName = res.userName;
				this.candidatesRoleData.name = res.personalDetails.firstName;
				this.candidatesRoleData.dob = res.personalDetails.dob;
				this.candidatesRoleData.gender = res.personalDetails.gender;
				this.candidatesRoleData.languagesKnown = [];
				this.candidatesRoleData.religion.name = res.personalDetails.religion;
				this.candidatesRoleData.category.name = res.personalDetails.category;
				this.candidatesRoleData.phone = res.contactDetails.phone;
				// this.candidatesData.address.country.name = res.contactDetails.communicationAddress.country;
				this.candidatesRoleData.address.country.name = res.contactDetails.communicationAddress.country;
				this.candidatesRoleData.address.addressLine1 = res.contactDetails.permanentAddress.address1;
				this.candidatesRoleData.address.landmark = res.contactDetails.permanentAddress.landmark;
				this.candidatesRoleData.address.pincode = res.contactDetails.communicationAddress.pinCode;
				this.candidatesRoleData.address.city.name = res.contactDetails.communicationAddress.city;
				this.candidatesRoleData.address.state.name = res.contactDetails.communicationAddress.state;
				this.candidatesRoleData.address.mandal.name = res.contactDetails.communicationAddress.districtDetails.parliamentaryConstituency;
				this.candidatesRoleData.address.district.name = res.contactDetails.communicationAddress.districtDetails.district;
				this.candidatesRoleData.email = res.contactDetails.email,
					this.candidatesRoleData.education = res.educationalDetails,
					this.candidatesRoleData.industrialExperience = [],
					this.candidatesRoleData.trainingExperience = []
				this.candidatesData = this.candidatesRoleData;
				console.log('new candidates', this.candidatesData);
			});
		}
	}

	getResponse() {
		this.batchservice.candidateDetails(this.username).subscribe((res)=> {
			console.log('message', res);
			this.data=res;
		})
	}

	getPaymentDetails() {
		this.paymentDetails = ''
		for (let index = 0; index < this.batchCandidates.length; index++) {
			if (this.batchCandidates[index].userName === this.username) {
				this.paymentDetails = this.batchCandidates[index].paymentDetails;
				console.log(this.paymentDetails);
				break;
			}
		}
	}

	getPassportDocument(document) {
		let data = document.split('-');
		const documentName = data[data.length - 1]
		return documentName;
	}

	backClicked() {
		this._location.back();
	}

	private _deriveNameFromS3Url(s3Url) {
		const file = decodeURIComponent(s3Url);
		const splitFile = file.split('/');
		return splitFile.pop();
	}
	showResume() {
		if (!this.candidatesData.resume || this.candidatesData.resume === '') {
			toastr.error('Resume is not available');
		}
	}

	createActionForm() {
		this.actionForm = this._formBuilder.group(
			{
				comment: ['', [Validators.required, Validators.maxLength(1000)]],
				reason: [[], [Validators.required]]
			});
	}

	submitComments(action) {
		if (action === 'AWAITING_BATCH_ENROLLMENT') {
			this.actionForm.get('comment').setErrors(null);
			this.actionForm.get('reason').setErrors(null);
		}
		if (this.actionForm.valid) {
			const data = {
				'status': action,
				'commentsBySSC': {
					'reason': action === 'REJECTED' ? this.actionForm.value.reason[0].itemName : '',
					'comment': this.actionForm.value.comment ? this.actionForm.value.comment : '',
					'commentedOn': new Date(),
				},
				'trainingReqId': Number(this.routeQueryParams.trReqId),
				'applicantId': this.routeParams.candidateId

			}
			this.userService.getTrainingRequest(data).subscribe(res => {
				if (action === 'AWAITING_BATCH_ENROLLMENT') {
					this.actionForRequest = false;
					Helpers.closeModal('accept-modal');
					swal('Request approved successfully!!', 'You have successfully approved the Training Request raised', 'success');
				} else if (action === 'REJECTED') {
					this.actionForRequest = false;
					Helpers.closeModal('reject-modal');
					swal('Request rejected successfully', 'You have successfully rejected the Training Request raised', 'error');
				}
				this.closeModal();
			})
		} else {
			toastr.error('form is not valid');
		}
	}

	closeModal() {
		this.actionForm.reset();
		this.actionForm.get('comment').setValue('');
		this.actionForm.get('reason').setValue([]);
		this.createActionForm();
	}

	getRejectReasons() {
		this.rejectedReasonsDropDownData = [{
			id: 0,
			itemName: 'Eligibility Criteria not met'
		}, {
			id: 0,
			itemName: 'Applicant not interested'
		}, {
			id: 0,
			itemName: 'Other'
		}]
	}

	approveCandidate() {
		const role = this.role.toLowerCase()
		console.log('approved', this.batchId, this.username)
		this.totBatchService.approveCandidate(this.batchId, this.username, 'ACCEPTED', '', role).subscribe(res => {
			if (res) {
				swal('<b>Applicant Approved</b>', 'Applicant successfully approved', 'success');
				this.router.navigate([`ssc/all-batches-new/batch-datails/${this.batchId}`])
				this.actionForApplicant = false;
			}
		}, err => {
			console.log('error while approve candidate', err);
		});
	}

	removeFormValidation() {
		this.actionForm.get('reason').setValidators([]);
		this.actionForm.get('reason').setErrors(null);
	}

	rejectApplicant() {
		if (this.actionForm.value.comment) {
			const data = {
				'userName': this.routeParams.candidateId,
				'batchId': Number(this.batchId),
				'comment': this.actionForm.value.comment,
			}
			const role = this.role && this.role ? (this.role).toLowerCase() : ''
			this.totBatchService.deleteApplicantPreferences(data, role).subscribe(res => {
				if (res) {
					Helpers.closeModal('reasonReject_modal')
					this.actionForApplicant = false;
					swal({
						title: 'Applicant Rejected',
						text: 'Applicant successfully rejected',
						type: 'success',
					});
				}
			}, err => {
				console.log('123123', err);
			});
		} else {
			toastr.error('please enter reason to reject applicant');
		}
	}

	downloadPdf(url) {
		this.fileService.downloadAttachedFile(url);
	}

	closeModalReason() {

	}

}

